import { baseUrlAssets as assets } from "./endpoints";

export const endpointsLayers = {
  projectLayersByProject: (projectId: number): string =>
    `${assets}/projects/${projectId}/layers`,
  projectLayerById: (projectId: number, layerId: number): string =>
    `${assets}/projects/${projectId}/layers/${layerId}`,
  layerDeletionRestriction: (projectId: number, layerId: number): string =>
    `${assets}/projects/${projectId}/layers/${layerId}/delete-restriction`,
};
